import styled from 'styled-components'
import { tokens } from '../../../assets/tokens'

const { color } = tokens

// Los consumidores meten su título como h4 (y un subtítulo h5) dentro de textContent
export const Body = styled.div`
  h4 {
    margin: 0;
    text-align: center;
    font-size: 18px;
    font-weight: 600;
    color: ${color.text.primary};
  }

  h5 {
    margin: 0;
    text-align: center;
    font-size: 14px;
    font-weight: 400;
    color: ${color.text.tertiary};
  }
`
